import { useState } from "react";
import { ClipboardList, CalendarDays } from "lucide-react";
import GeneralView from "./clinical/GeneralView";
import DatedView from "./clinical/DatedView";

export default function ClinicalData({ patient, onSaved }) {
  const [view, setView] = useState("geral");

  const toggle = (v, Icon, txt, tid) => (
    <button onClick={() => setView(v)} data-testid={tid}
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-body transition-colors ${view === v ? "bg-[#5B6E5B] text-[#FDFBF7]" : "border border-[#5B6E5B]/20 text-[#4A5D4E] hover:bg-white"}`}>
      <Icon className="w-4 h-4" /> {txt}
    </button>
  );

  return (
    <div data-testid="clinical-data">
      <div className="flex flex-wrap gap-2 mb-6">
        {toggle("geral", ClipboardList, "Geral", "clinical-view-geral")}
        {toggle("datas", CalendarDays, "Por data da sessão", "clinical-view-datas")}
      </div>
      {view === "geral"
        ? <GeneralView patient={patient} onSaved={onSaved} />
        : <DatedView patient={patient} />}
    </div>
  );
}
